import { diagnosisItems } from "features/cdm/cdm/constants/diagnosisItems";
import { PRIVATE_FINANCIAL_CLASS } from "features/cdm/constants/pcrsSchemeCheck";

// A Private patient may only be on the CDM Treatment Programme for Diabetes, so
// Diabetes Type 2 is the sole eligible condition for them.
export const PRIVATE_ELIGIBLE_CDM_DIAGNOSIS_IDS = ["DIABETES_TYPE_2"];

export const isPrivatePatient = (financialClass) =>
  financialClass === PRIVATE_FINANCIAL_CLASS;

// The diagnosis codes a patient may be registered/reviewed under: only Diabetes
// for Private patients, all conditions otherwise.
export const getEligibleCdmDiagnosisIds = (financialClass) =>
  isPrivatePatient(financialClass)
    ? PRIVATE_ELIGIBLE_CDM_DIAGNOSIS_IDS
    : diagnosisItems.map((item) => item.id);

// A CDM review is eligible when every one of its diagnoses is permitted for the
// patient's financial class. `null`/`undefined` diseaseIds means the condition
// is not yet known (e.g. per-review details still loading) — treat as eligible
// so a legitimate Diabetes review is never hidden while it resolves.
export const isCdmReviewEligible = (diseaseIds, financialClass) => {
  if (!isPrivatePatient(financialClass)) return true;
  if (diseaseIds == null) return true;

  const eligibleIds = getEligibleCdmDiagnosisIds(financialClass);

  return diseaseIds.every((id) => eligibleIds.includes(id));
};
